import img2000 from '../../assets/img/gallery/2000.jpg';
import img2001 from '../../assets/img/gallery/2001.jpg';
import img2006 from '../../assets/img/gallery/2006.jpg';
import img2007 from '../../assets/img/gallery/2007.jpg';
import img2008 from '../../assets/img/gallery/2008.jpg';
import img2010 from '../../assets/img/gallery/2010.jpg';

export const VerticalTimelineData = [
  {
    title: 'iPhone 13 released',
    description:
      'Most advanced dual‑camera system ever. Durability that’s front and center. And edge to edge. A lightning-fast chip that leaves the competition behind.',
    year: '2021',
    date: '24 September',
    icon: 'mobile'
  },
  {
    title: 'iPad  launched',
    description:
      'Following on from the success of their iPhone launches and the popularity of lighter, more portable laptops, the iPad was born in 2010, combining the best features of both products. ',
    year: '2010-2014',
    date: '03 April',
    icon: 'fire'
  },
  {
    title: 'MacBook Air released',
    description:
      'Along with releasing the next generation of the iPhone, the iPhone 3G, Apple also released the MacBook Air which would set the precedent across the industry for thinner, lighter laptops. ',
    year: '2008',
    date: '15 January',
    icon: 'book-open'
  },
  {
    title: 'First generation iphone',
    description:
      'The first-generation iPhone was released with a mere 4GB storage and would launch the company into a new portable internet age of smartphones.',
    year: '2007',
    date: '01 January',
    icon: 'rocket'
  },
  {
    title: 'Apple IIc & The Mac',
    description:
      '1984 saw the rise of the Apple IIc, the first portable computer which was intended to be carried around but had no battery, this meant that a power socket would need to be nearby for you to use it.',
    year: '1984',
    date: '24 April',
    icon: 'tint'
  },
  {
    title: 'Apple I was launched',
    description:
      'July 1st, 1976 was when the Apple I was launched, designed and built by Steve Wozniak, the co-founder of Apple. However, it was Steve Jobs who had the idea to sell the computer and it was there that the Apple empire was born.',
    year: '1976',
    date: '01 July',
    icon: 'flag'
  }
];
export const ZigzagTimelineData = [
  {
    year: '2000',
    title: '1 Ghz pentium and athlon',
    description:
      'AMD and intel release chips clocked at 1 GHz. Sony releases the play station 2.',
    img: {
      img: img2000,
      classes: 'rounded',
      height: '250',
      width: '188'
    }
  },
  {
    year: '2001',
    title: 'Mac OS X/ windows XP',
    description:
      'New version of the three major operation systems are released.',
    img: {
      img: img2001,
      classes: 'rounded',
      height: '250',
      width: '188'
    }
  },

  {
    year: '2006',
    title: 'Macbook pro/Intel core 2/wifi',
    description:
      'The Macbook pro, their first dual-core intel based mobile computer. Sony and Nintendo release the PS3 and will respectively.',
    img: {
      img: img2006,
      classes: 'rounded',
      height: '250',
      width: '188'
    }
  },
  {
    year: '2007',
    title: 'Iphone/ASUS Eee pc',
    description:
      'The first iphone was introduces by Apple. The first ASUS Eee introduces the netbook category of laptops',
    img: {
      img: img2007,
      classes: 'rounded',
      height: '250',
      width: '188'
    }
  },
  {
    year: '2008',
    title: 'HTC Dream/Google android',
    description:
      'The HTC Dream is released- the first  commercially available phone to run the newly released android operating  system by google.',
    img: {
      img: img2008,
      classes: 'rounded',
      height: '250',
      width: '188'
    }
  },
  {
    year: '2010',
    title: 'Ipad',
    description:
      'Apple released the ipad, a tablet computer that bridges the gap between smartphones and laptops.',
    img: {
      img: img2010,
      classes: 'rounded',
      height: '250',
      width: '188'
    }
  }
];
